<template>
  <div>
    <v-row>
      <page-title value="園設定"></page-title>
    </v-row>

    <!-- <v-tabs v-model="tab" class="pt-6"> -->
      <!-- <v-tab href="#update">施設アカウント</v-tab> -->
      <!-- <v-tab href="#switch">園切り替え</v-tab> -->

      <!-- 施設アカウント PUTのみ -->
      <!-- <v-tab-item value="update">
      <v-container class="pt-4">

        <v-row>
          <v-col cols="6" align-self="center">
            <div>保育園名</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.nurseryName" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>施設コード</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.nurseryCode" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>自治体コード</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.localAuthorityCode" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>郵便番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.postalCode" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>都道府県</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.prefecture" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>住所</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.address" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>建物名</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.building" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>電話番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.phoneNumber" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>FAX番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.faxNumber" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>施設メールアドレス</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.representativeEmail" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

      <v-row class="py-2">
        <v-divider></v-divider>
      </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>法人名</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.companyName" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>郵便番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.postalCode" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>都道府県</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.prefecture" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>住所</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.address" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>建物・部屋番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.building" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>電話番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.phoneNumber" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>FAX番号</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.faxNumber" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>代表者姓</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.representativeLastName" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>代表者名</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.representativeFirstName" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>代表者姓（カナ）</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.representativeLastNameKana" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

       <v-row>
          <v-col cols="6" align-self="center">
            <div>代表者姓（カナ）</div>
          </v-col>
          <v-col cols="6" align-self="center">
            <v-text-field v-model="input.companyInfo.representativeFirstNameKana" variant="outlined" density="compact" hide-details></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" class="pt-4">
          <v-col cols="3">
            <v-btn
              @click="updateNursery"
              :loading="loading"
              color="primary"
              variant="flat"
              block
            >
            更新
            </v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-tab-item> -->

      <!-- 園 切り替え -->
      <!-- <v-tab-item value="switch"> -->
        <v-container class="pt-10">
          <v-row>
            <v-col cols="5">
              <div>園切り替え</div>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="schools"
                v-model="selectedNurseryId"
                item-title="nurseryName"
                item-value="nurseryId"
                variant="outlined"
                density="compact"
                hide-details
                :disabled="loading"
                color="primary"
              >
              </v-select>
            </v-col>
            <v-col cols="2">
              <v-btn @click="saveNurseryId" block color="primary" variant="flat"
                >変更</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      <!-- </v-tab-item> -->
    <!-- </v-tabs> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import ValidationMixin from "@/mixins/ValidationMixin";
import Swal from "sweetalert2";
import { meModule } from "@/store/dataModules/meModule";
import LocalDataService from "@/service/LocalDataService";
import ApiAdmin from "@/api/ApiAdmin";
import { MeResponse } from "chaild-api/lib";

export default defineComponent({
  name: "Admin",

  mixins: [ValidationMixin],

  components: {
    PageTitle,
  },

  data() {
    return {
      valid: false,
      tab: null,
      selectedNurseryId: null as number | null,
      loading: false,
      input: {
        nurseryName: "",
        nurseryCode: "",
        localAuthorityCode: "",
        postalCode: "",
        prefecture: "",
        address: "",
        building: "",
        phoneNumber: "",
        faxNumber: "",
        representativeEmail: "",
        companyInfo: {
          companyName: "",
          postalCode: "",
          prefecture: "",
          address: "",
          building: "",
          phoneNumber: "",
          faxNumber: "",
          representativeFirstName: "",
          representativeLastName: "",
          representativeFirstNameKana: "",
          representativeLastNameKana: "",
        },
      },
    };
  },

  async mounted() {
    await this.fetchMe();
    const nurseryId = LocalDataService.getNurseryId();
    const me: MeResponse | null = meModule.me;
    if (nurseryId && me) {
      // isDefault == trueのnurseryIdをデフォルトで選択
      const currentSchool = me.nurserySchools.find((s) => {
        return s.isDefault == true;
      });
      this.selectedNurseryId = currentSchool?.nurseryId
        ? currentSchool.nurseryId
        : nurseryId;
    }
  },

  computed: {
    schools: function () {
      return meModule.me?.nurserySchools;
    },
  },

  methods: {
    async fetchMe() {
      await meModule.fetchMe();
    },
    async saveNurseryId() {
      if (this.selectedNurseryId) {
        LocalDataService.setNurseryId(this.selectedNurseryId);
        meModule.setNurseryId(this.selectedNurseryId);
        const response = await meModule.putMe({
          defaultNurseryId: this.selectedNurseryId,
        });
        if (response) {
          Swal.fire({ title: "変更しました", icon: "success" }).then(() => {
            window.location.reload();
          });
        }
      }
    },
    async updateNursery() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiAdmin.updateNursery({
          nurseryId: String(nurseryId),
          ...this.input,
        });
        if (response) {
          Swal.fire({ title: "更新しました", icon: "success" });
          this.$router.push({ path: "/setting/staff" }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({ title: "失敗しました", icon: "error" });
        }
      }

      this.loading = false;
    },
  },
});
</script>
